import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
registerLocale('datepicker-es', es);

const localePicker = (locale) => {
  const registeredLocale = {
    es: 'datepicker-es',
  };
  return registeredLocale[locale] || 'en';
};

export default localePicker;
